import { useState, useEffect } from "react"
import { Link } from "gatsby"
import { RiAccountCircleLine } from "react-icons/ri"
import ChevronDown from "@/assets/svg/chevron-down.svg"
import DropdownNav from "@/components/DropdownNav"
import * as styles from "@/styles/modules/NavItem.module.scss"

export default function NavItem({
  children,
  enableDropdowns,
  forceTheme,
  isUserNavItem,
  itemText,
  linkData,
  rightAlignDropdown,
}) {
  const [dropdownVisible, setDropdownVisible] = useState(enableDropdowns)

  const { internalLink, blank, href, title, linkType } = linkData

  useEffect(() => {
    // Hide dropdowns only when scrolling down
    // (when enableDropdowns is previously true)
    setDropdownVisible(enableDropdowns && !enableDropdowns)
  }, [enableDropdowns])

  function handleEvent(e) {
    switch (e.type) {
      case "mouseenter":
      case "focus":
        setDropdownVisible(true)
        break
      case "mouseleave":
      case "blur":
        setDropdownVisible(false)
        break
      default:
        break
    }
  }

  const linkChildren = (
    <>
      {itemText}
      {isUserNavItem && <RiAccountCircleLine className={styles.userIcon} />}
      {children && <ChevronDown className={styles.chevron} />}
    </>
  )

  const itemTextStyles = [
    styles.itemText,
    forceTheme ? styles[`force${forceTheme}`] : "",
  ].join(" ")

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={styles.item}
      onMouseEnter={handleEvent}
      onMouseLeave={handleEvent}
      onFocus={handleEvent}
      onBlur={handleEvent}
    >
      {linkType === "internal" && internalLink ? (
        <Link
          to={internalLink}
          className={itemTextStyles}
          title={title}
          tabIndex="0"
          activeClassName={styles.active}
        >
          {linkChildren}
        </Link>
      ) : linkType === "external" && href ? (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
          className={itemTextStyles}
          href={href}
          title={title}
          target={blank ? "_blank" : null}
          rel={blank ? "noreferrer" : null}
        >
          {linkChildren}
        </a>
      ) : (
        <p className={itemTextStyles}>{linkChildren}</p>
      )}

      {children && (
        <DropdownNav
          isVisible={dropdownVisible}
          rightAligned={rightAlignDropdown}
        >
          {children}
        </DropdownNav>
      )}
    </div>
  )
}

NavItem.defaultProps = {
  linkData: {},
}
